function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 4.75L4.75 8S4 19.25 12 19.25 19.25 8 19.25 8L12 4.75z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11.845A1.673 1.673 0 1012 8.5a1.673 1.673 0 000 3.345zM9.348 15.34h5.304c.588 0 1.04-.505.766-1.024-.404-.765-1.324-1.677-3.418-1.677-2.094 0-3.014.912-3.418 1.677-.274.52.178 1.025.766 1.025z",
  fill: "currentColor"
});

function SvgAdminIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgAdminIcon;